// extracted by mini-css-extract-plugin
export default {"logo":"logo-Vjhhx","stars":"stars-_NUHi","text":"text-fl2f7","lightText":"lightText-bghHd","flat":"flat-s_Vdx","row":"row-tfkOK","compact":"compact-O5mU4"};